export enum SearchType {
  FLIGHT = "FLIGHT",
  HOTEL = "HOTEL",
  CAR = "CAR",
}

export enum JourneyType {
  ONEWAY = "OneWay",
  ROUND_TRIP = "Return"
}

export enum CarRentalType {
  SAME_DROP = "SAME_DROP",
  DIFFERENT_DROP = "DIFFERENT_DROP",
}

export enum FlightType {
  ECONOMY = "Economy",
  BUSINESS = 'Business',
  FIRST_CLASS= 'First',
  PREMIUM_ECONOMY = 'PremiumEconomy',
}

export enum FlightDirection {
  MULTIPLE_STOPS,
  DIRECT,
  BOTH_DIRECT,
  ALL,
}

export enum Currency {
  USD = "USD",
  EUR = "EUR",
}

export interface FlightSearchRequest {
   journeyType: JourneyType,
    directFlight: FlightDirection,
    OriginDestinationInfo: [
        {
            departureDate: Date,
            returnDate?: Date,
            airportOriginCode: string,
            airportDestinationCode: string
        }
    ],
    class: FlightType,
    adults: number,
    childs: number,
    infants: number,
    requiredCurrency: Currency
}

export interface HotelSearchRequest {
   city_name: string,
   country_name: string,
   checkin: Date,
   checkout: Date,
   resultsPerPage: number,
   maxResults: number,
   occupancy: [{
     room_no: number,
     adult: number,
     child: number,
     child_age: number[]
   }];
   roomAndGuest?: {
    adultCount: number,
    childCount: number,
    roomCount: number
   }
}

export interface CarSearchRequest {
  pickup_id: string;
  dropoff_id: string;
  pickup_location: string;
  dropoff_location: string;
  pickup_date: string;
  pickup_time: string;
  dropoff_date: string;
  dropoff_time: string;
  driver_age: number;
  currency: string;
  country_res: string;
  sorting: string;
}

export interface Location {
  id?: number;
  code: string;
  name: string;
  city: string;
  country: string;
  latitude: string;
  longitude: string;
}
export interface City {
  id: number;
  cityName: string;
  countryName: string;
  latitude: string;
  longitude: string;
}



